var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
import { DashboardClientService } from '../../../../services/dashboard/dashboard-client.service';
var AddNewDashboardDialog = /** @class */ (function () {
    function AddNewDashboardDialog(dialogClient, dashboardClientService) {
        this.dialogClient = dialogClient;
        this.dashboardClientService = dashboardClientService;
        this.isNew = true;
        this.globalDashboards = [];
        this.dashboard = {
            id: 0,
            createdDate: new Date(),
            dashboardId: 0,
            dashboardWidgets: [],
            name: "",
            atRoleLevel: false
        };
    }
    AddNewDashboardDialog.prototype.cancel = function () {
        this.dialogClient.hide();
    };
    AddNewDashboardDialog.prototype.saveDashboard = function () {
        var _this = this;
        if (!this.isNew && this.globalDashboardSelected) {
            this.dashboard = this.globalDashboardSelected;
            this.dashboard.atRoleLevel = true;
        }
        console.log('saving dashboard');
        this.dashboardClientService.persistDashboard(this.dashboard, false, !this.isNew).then(function (response) {
            if (_this.dashboard.id === 0 || !_this.isNew) {
                _this.dashboardViewModel.dashboards.push(response.dashboard);
                _this.dashboardViewModel.onDashboardSelected(response.dashboard);
            }
            else { //editing
            }
            _this.dialogClient.hide();
        });
    };
    AddNewDashboardDialog.prototype.isDashboardChecked = function (index) {
        return index == 0;
    };
    AddNewDashboardDialog.prototype.activate = function (model) {
        var _this = this;
        this.dashboardViewModel = model;
        var promise1 = this.dashboardClientService.getDashbardsForUser();
        var promise2 = this.dashboardClientService.getGlobalDashboardsForUser();
        Promise.all([promise1, promise2]).then(function (x) {
            var appliedDashboards = x[0].dashboards.map(function (y) { return y.dashboardId; });
            _this.globalDashboards = x[1].dashboards.filter(function (x) { return appliedDashboards.indexOf(x.dashboardId) == -1; });
        });
    };
    AddNewDashboardDialog = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [DialogClientService, DashboardClientService])
    ], AddNewDashboardDialog);
    return AddNewDashboardDialog;
}());
export { AddNewDashboardDialog };
